import Router from './Router';

export const router = new Router();
